import React, { FC } from 'react';
import { Maximize, ZoomIn, ZoomOut } from 'lucide-react';

import { ZOOM_FACTOR } from '@/components/blocks/annotator/constants';
import type {
  AnnotatorLabels,
  AnnotatorMode,
} from '@/components/blocks/annotator/types';
import { Button } from '@/components/ui/button';

interface AnnotatorToolBarContainerProps {
  children?: Array<React.ReactNode>;
  mode: AnnotatorMode;
  labels: AnnotatorLabels;
  zoom: (factor: number) => void;
  fit: () => void;
}

export const AnnotatorToolBarContainer: FC<AnnotatorToolBarContainerProps> = ({
  labels,
  children,
  zoom,
  fit,
}: AnnotatorToolBarContainerProps) => (
  <div className='border-primary bg-background/90 absolute top-2 left-2 z-10 flex items-center gap-1 rounded-lg border p-1 shadow-sm backdrop-blur'>
    {children}
    <Button
      type='button'
      variant='outline'
      size='icon'
      aria-label={labels.zoomIn}
      title={labels.zoomIn}
      onClick={() => {
        zoom(ZOOM_FACTOR);
      }}>
      <ZoomIn />
    </Button>
    <Button
      type='button'
      variant='outline'
      size='icon'
      aria-label={labels.zoomOut}
      title={labels.zoomOut}
      onClick={() => {
        zoom(1 / ZOOM_FACTOR);
      }}>
      <ZoomOut />
    </Button>
    <Button
      type='button'
      variant='outline'
      size='icon'
      aria-label={labels.resetZoom}
      title={labels.resetZoom}
      onClick={fit}>
      <Maximize />
    </Button>
  </div>
);
